// Modusbox icons
require('./modusbox/arrow.svg');
require('./modusbox/business-group.svg');
require('./modusbox/circle.svg');
require('./modusbox/cloud.svg');
require('./modusbox/documents.svg');
require('./modusbox/question-mark.svg');
require('./modusbox/warning-sign.svg');
require('./mule/check-small.svg');
require('./mule/close-small.svg');
require('./mule/download-small.svg');
require('./mule/duplicate-small.svg');
require('./mule/edit-small.svg');
require('./mule/info-small.svg');
require('./mule/plus-small.svg');
require('./mule/search.svg');
require('./mule/search-small.svg');
require('./mule/studio-project-small.svg');
require('./mule/trash-small.svg');
require('./mule/upload-small.svg');
require('./mule/user-small.svg');
// require('./modusbox/business-processes.svg');
// require('./modusbox/transmissions.svg');
// require('./modusbox/transactions.svg');
// require('./modusbox/errors.svg');
// require('./modusbox/toggle-visible.svg');
// require('./modusbox/toggle-invisible.svg');
// require('./modusbox/transaction-child.svg');
// require('./modusbox/transaction-parent.svg');
// require('./modusbox/transaction-standalone.svg');
// require('./modusbox/onhold.svg');
// require('./modusbox/inactive.svg');
// require('./modusbox/double-arrow.svg');
// require('./modusbox/dash.svg');
// require('./modusbox/saved.svg');
// require('./modusbox/editing.svg');
// require('./modusbox/magic-wand.svg');
// require('./modusbox/settings.svg');

// Mulesoft icons
// require('./mule/access-manager-color.svg');
// require('./mule/access-manager-greyscale.svg');
// require('./mule/admin-color.svg');
// require('./mule/admin-greyscale.svg');
// require('./mule/alert-not-active-small.svg');
// require('./mule/alert-not-active.svg');
// require('./mule/alert-small.svg');
// require('./mule/alert.svg');
// require('./mule/api-analytics-color.svg');
// require('./mule/api-analytics-greyscale.svg');
// require('./mule/api-color.svg');
// require('./mule/api-designer-color.svg');
// require('./mule/api-designer-greyscale.svg');
// require('./mule/api-greyscale.svg');
// require('./mule/api-manager-color.svg');
// require('./mule/api-manager-greyscale.svg');
// require('./mule/api-notebook-color.svg');
// require('./mule/api-notebook-greyscale.svg');
// require('./mule/api-portal-color.svg');
// require('./mule/api-portal-greyscale.svg');
// require('./mule/application-color.svg');
// require('./mule/application-greyscale.svg');
// require('./mule/application-small.svg');
// require('./mule/application.svg');
// require('./mule/arrow-down-small.svg');
// require('./mule/arrow-up-small.svg');
// require('./mule/back-small.svg');
// require('./mule/back.svg');
// require('./mule/businessgroup-small.svg');
// require('./mule/calendar-small.svg');
// require('./mule/calendar.svg');
// require('./mule/check-all-small.svg');
// require('./mule/check.svg');
// require('./mule/circle-plus-small.svg');
// require('./mule/close.svg');
// require('./mule/cloud-extender-color.svg');
// require('./mule/cloud-extender-greyscale.svg');
// require('./mule/cloud-small.svg');
// require('./mule/cloudhub-color.svg');
// require('./mule/cloudhub-greyscale.svg');
// require('./mule/cloudhub-small.svg');
// require('./mule/cloudhub.svg');
// require('./mule/cluster-small.svg');
// require('./mule/cluster.svg');
// require('./mule/code-small.svg');
// require('./mule/code.svg');
// require('./mule/connector-devkit-color.svg');
// require('./mule/connector-devkit-greyscale.svg');
// require('./mule/connectors-color.svg');
// require('./mule/connectors-greyscale.svg');
// require('./mule/contextmenu.svg');
// require('./mule/copy-to-clipboard-small.svg');
// require('./mule/copy-to-clipboard.svg');
// require('./mule/dashboard.svg');
// require('./mule/data-gateway-color.svg');
// require('./mule/data-gateway-greyscale.svg');
// require('./mule/data-loader-color.svg');
// require('./mule/data-loader-greyscale.svg');
// require('./mule/data-weave-color.svg');
// require('./mule/data-weave-greyscale.svg');
// require('./mule/debug-small.svg');
// require('./mule/deploy-medium.svg');
// require('./mule/deploy-small.svg');
// require('./mule/design-center-color.svg');
// require('./mule/design-center-greyscale.svg');
// require('./mule/destination-small.svg');
// require('./mule/destination.svg');
// require('./mule/detail-pane.svg');
// require('./mule/documentation-medium.svg');
// require('./mule/documentation-small.svg');
// require('./mule/documentation.svg');
// require('./mule/download-center-small.svg');
// require('./mule/download.svg');
// require('./mule/duplicate.svg');
// require('./mule/edit-modal-small.svg');
// require('./mule/edit.svg');
// require('./mule/encrypted-small.svg');
// require('./mule/encrypted.svg');
// require('./mule/environment-small.svg');
// require('./mule/exchange-logo-empty.svg');
// require('./mule/exchange-logo-filled.svg');
// require('./mule/exchange-small.svg');
// require('./mule/exchange.svg');
// require('./mule/filter-small.svg');
// require('./mule/filter.svg');
// require('./mule/forum-small.svg');
// require('./mule/forward-small.svg');
// require('./mule/github.svg');
// require('./mule/grid.svg');
// require('./mule/hybrid-cloud-color.svg');
// require('./mule/hybrid-small.svg');
// require('./mule/id-small.svg');
// require('./mule/id.svg');
// require('./mule/info.svg');
// require('./mule/key-small.svg');
// require('./mule/key.svg');
// require('./mule/link-small.svg');
// require('./mule/link.svg');
// require('./mule/list.svg');
// require('./mule/location-small.svg');
// require('./mule/lock-small.svg');
// require('./mule/lock.svg');
// require('./mule/mail-small.svg');
// require('./mule/manage-center-color.svg');
// require('./mule/manage-center-greyscale.svg');
// require('./mule/manage-medium.svg');
// require('./mule/manage.svg');
// require('./mule/message-pull.svg');
// require('./mule/message-purge.svg');
// require('./mule/message-push.svg');
// require('./mule/message-queue-color.svg');
// require('./mule/message-queue-greyscale.svg');
// require('./mule/message-small.svg');
// require('./mule/message.svg');
// require('./mule/monitor-medium.svg');
// require('./mule/more-small.svg');
// require('./mule/monitor.svg');
// require('./mule/mule.svg');
// require('./mule/mulesoft-logo.svg');
// require('./mule/notification-small.svg');
// require('./mule/on-prem-small.svg');
// require('./mule/open.svg');
// require('./mule/partner-manager-color.svg');
// require('./mule/pin-small.svg');
// require('./mule/partner-manager-greyscale.svg');
// require('./mule/pin.svg');
// require('./mule/platform-services-color.svg');
// require('./mule/platform-services-greyscale.svg');
// require('./mule/playground-color.svg');
// require('./mule/playground-greyscale.svg');
// require('./mule/plus-medium.svg');
// require('./mule/queue-small.svg');
// require('./mule/plus.svg');
// require('./mule/queue.svg');
// require('./mule/redo-small.svg');
// require('./mule/redo.svg');
// require('./mule/refresh-small.svg');
// require('./mule/refresh.svg');
// require('./mule/runtime-manager-color.svg');
// require('./mule/runtime-manager-greyscale.svg');
// require('./mule/runtime-services-color.svg');
// require('./mule/runtime-services-greyscale.svg');
// require('./mule/server-group.svg');
// require('./mule/server-group-small.svg');
// require('./mule/server-small.svg');
// require('./mule/server.svg');
// require('./mule/settings-greyscale.svg');
// require('./mule/settings-color.svg');
// require('./mule/settings-small.svg');
// require('./mule/settings.svg');
// require('./mule/sign-in.svg');
// require('./mule/share-small.svg');
// require('./mule/sign-out.svg');
// require('./mule/spinner.svg');
// require('./mule/studio-example-small.svg');
// require('./mule/star-circle.svg');
// require('./mule/studio-color.svg');
// require('./mule/studio-example.svg');
// require('./mule/studio-greyscale.svg');
// require('./mule/studio-project.svg');
// require('./mule/studio-template.svg');
// require('./mule/studio-template-small.svg');
// require('./mule/support-portal-small.svg');
// require('./mule/support-small.svg');
// require('./mule/support.svg');
// require('./mule/tag-small.svg');
// require('./mule/talk-small.svg');
// require('./mule/talk.svg');
// require('./mule/test-1_.svg');
// require('./mule/time-small.svg');
// require('./mule/time.svg');
// require('./mule/timer.svg');
// require('./mule/training-small.svg');
// require('./mule/trash.svg');
// require('./mule/undo-small.svg');
// require('./mule/undo.svg');
// require('./mule/unlock-small.svg');
// require('./mule/upload.svg');
// require('./mule/user.svg');
// require('./mule/walkthrough-small.svg');
// require('./mule/warning-small.svg');
// require('./mule/warning.svg');
// require('./mule/xchange-color.svg');
// require('./mule/xchange-greyscale.svg');
